import LoaderOverlay from '@allesauto/core/loaderOverlay';
import React, { FC, ReactNode } from 'react';

export interface PDPLayoutProps {
  headerContent: ReactNode;
  footerContent: ReactNode;
  isLoading?: boolean;
  loaderDescriptionText?: string;
}

const PDPLayout: FC<React.PropsWithChildren<PDPLayoutProps>> = ({
  headerContent,
  footerContent,
  children,
  isLoading = false,
  loaderDescriptionText,
}) => (
  <>
    {isLoading && <LoaderOverlay descriptionText={loaderDescriptionText} />}
    {headerContent}
    <div className="container grid grid-cols-24 max-w-screen-xl mx-auto w-full">
      <main className="col-span-24">{children}</main>
    </div>
    {footerContent && (
      <footer className="bg-grey90 pb-0 text-white md:pb-100px">
        {footerContent}
      </footer>
    )}
  </>
);

export default PDPLayout;
